<template>
    <div style="text-align: center">
        <h1>{{title}}</h1>
        <p>{{msg}}</p>
    </div>    
</template>

<script>
export default {
    props: ["title","msg"]
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/PageNotFound.vue